import { components } from '@/api/skippay/generated/selfCare';
import { FIELD_BANK_CODE, FIELD_SECOND_PART, FIELD_THIRD_PART } from '@mallpay/orbis';

export enum STEP_SLUGS {
	INSURANCE_NUMBER = 'insurance-number',
	EVENT_TYPE = 'event-type',
	DOCUMENTS = 'documents',
	MAIN_INFORMATION = 'details',
	RESULT = 'result',
}

export type StepSlug = (typeof STEP_SLUGS)[keyof typeof STEP_SLUGS];

export const EVENT_TYPE_VALUES = {
	THEFT: 'theft',
	DAMAGE: 'damage',
	WARRANTY: 'warranty',
} as const;

export type EventType = (typeof EVENT_TYPE_VALUES)[keyof typeof EVENT_TYPE_VALUES];

export const FIELD_INSURANCE_NUMBER = 'insuranceNumber' as const;
export const FIELD_EVENT_TYPE = 'eventType' as const;
export const FIELD_RECEIPT = 'receipt' as const;
export const FIELD_PHOTOS = 'photos' as const;
export const FIELD_POLICE_REPORT = 'policeReport' as const;
export const FIELD_INCIDENT_DATE = 'incidentDate' as const;
export const FIELD_INCIDENT_PLACE = 'incidentPlace' as const;
export const FIELD_INCIDENT_DESCRIPTION = 'incidentDescription' as const;
export const FIELD_FULL_NAME = 'fullName' as const;
export const FIELD_DATE_OF_BIRTH = 'birthDate' as const;
export const FIELD_EMAIL = 'email' as const;
export const FIELD_PHONE = 'phone' as const;
export const FIELD_BANK_ACCOUNT = 'bankAccount' as const;

export type BankAccountValue = {
	[FIELD_BANK_CODE]: string;
	[FIELD_SECOND_PART]: string;
	[FIELD_THIRD_PART]?: string;
};

export type InsuranceReportFormValues = {
	[FIELD_INSURANCE_NUMBER]: string;
	[FIELD_EVENT_TYPE]?: EventType | undefined;
	[FIELD_RECEIPT]?: components['schemas']['File'][];
	[FIELD_PHOTOS]?: components['schemas']['File'][];
	[FIELD_POLICE_REPORT]?: components['schemas']['File'][];
	[FIELD_INCIDENT_DATE]?: string;
	[FIELD_INCIDENT_PLACE]?: string;
	[FIELD_INCIDENT_DESCRIPTION]?: string;
	[FIELD_FULL_NAME]?: string;
	[FIELD_DATE_OF_BIRTH]?: string;
	[FIELD_EMAIL]?: string;
	[FIELD_PHONE]?: string;
	[FIELD_BANK_ACCOUNT]?: BankAccountValue;
};

export type SubmissionStatus = 'idle' | 'success' | 'error';

export const stepOrder: StepSlug[] = [
	STEP_SLUGS.INSURANCE_NUMBER,
	STEP_SLUGS.EVENT_TYPE,
	STEP_SLUGS.DOCUMENTS,
	STEP_SLUGS.MAIN_INFORMATION,
	STEP_SLUGS.RESULT,
];
